import { render, staticRenderFns } from "./after_sale_content.vue?vue&type=template&id=4451feab&scoped=true"
import script from "./after_sale_content.vue?vue&type=script&lang=js"
export * from "./after_sale_content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4451feab",
  null
  
)

export default component.exports